export default __webpack_public_path__ + "static/WORTHIT_PINK-efb914396a422d2e3f5bca514453adb6.png";